import type { TimelineItem } from '../HistoryDialog.types.ts';

type StepDeletionActionProps = {
  item: TimelineItem<'DELETE_STEP'>;
};

export const StepDeletionAction: React.FC<StepDeletionActionProps> = () => null;
